import React, { useEffect, useState } from "react";
import Heading from "../../Components/Heading/Heading";
import axios from "axios";
import DataTable from "../../Components/DataTable/DataTable";
import { useNavigate } from "react-router-dom";
import { PencilSquare, TrashFill } from "react-bootstrap-icons";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useTheme,
} from "@mui/material";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";

function Sites() {
  const [data, setData] = useState();
  const [deletedId, setDeleteId] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const role = useSelector((state) => state.auth.role.roleName);
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/sites/`, { withCredentials: true })
      .then((res) => {
        setData(res.data);
      })
      .catch((error) => {
        toast.error(error?.message);
      });
  }, []);

  const columns = [
    { field: "id", headerName: "رمز التعريف", width: 90 },
    { field: "name", headerName: "إسم الموقع", width: 300 },
    { field: "type", headerName: "نوع الموقع", width: 150 },
    {
      field: "action",
      headerName: "",
      sortable: false,
      disableColumnMenu: true,
      width: 150,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
            }}
          >
            {role === "SuperAdmin" || role === "Admin" ? (
              <Button
                variant="contained"
                sx={{
                  width: "36px",
                  height: "36px",
                  padding: 0,
                  margin: 0,
                  minWidth: "auto",
                  backgroundColor: theme.palette.neutral[50],
                  "&:hover": {
                    backgroundColor: theme.palette.neutral[100],
                  },
                }}
                onClick={() => handleEditClick(params.row)}
                disableElevation
              >
                <PencilSquare size={16} color={theme.palette.primary[600]} />
              </Button>
            ) : (
              ""
            )}
            {role === "SuperAdmin" ? (
              <Button
                variant="contained"
                sx={{
                  width: "36px",
                  height: "36px",
                  padding: 0,
                  margin: 0,
                  minWidth: "auto",
                  backgroundColor: theme.palette.neutral[50],
                  "&:hover": {
                    backgroundColor: theme.palette.neutral[100],
                  },
                }}
                onClick={() => handleDeleteClick(params.row.id)}
                disableElevation
              >
                <TrashFill size={16} color={theme.palette.primary[600]} />
              </Button>
            ) : (
              ""
            )}
          </Box>
        );
      },
    },
  ];

  const handleEditClick = (data) => {
    navigate(`/app/sites/edit/${data.id}`, { state: data });
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setOpenDialog(true);
  };

  const handleDelete = async () => {
    if (deletedId) {
      try {
        const res = await axios.delete(
          `${process.env.REACT_APP_API_URL}/sites/${deletedId}`,
          {
            withCredentials: true,
          }
        );
        if (res) {
          toast.success("تم حذف الموقع بنجاح!");
          setData((prevData) =>
            prevData.filter((item) => item.id !== deletedId)
          );
          setDeleteId(null);
        }
      } catch (error) {
        toast.error(error.message);
        setDeleteId(null);
      }
    }
    setOpenDialog(false);
  };

const onButtonClick = (url) => {
  navigate(url);
};

  const handleCloseDialog = () => setOpenDialog(false);

  return (
    <div>
      <Heading
        title="المواقع"
        button="إضافة موقع جديد"
        onButtonClick={() => onButtonClick("/app/sites/new")}
      />
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"تأكيد الحذف"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            هل أنت متأكد من أنك تريد حذف هذا الموقع
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} autoFocus color={"error"}>
            إغلاق
          </Button>
          <Button onClick={handleDelete} variant="contained" color={"error"}>
            حذف
          </Button>
        </DialogActions>
      </Dialog>
      <DataTable data={data} dataColumns={columns} />
    </div>
  );
}

export default Sites;
